import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {Router} from "@angular/router";
import * as fromStore from "../../../../store";
import {DbStoreState} from "../../../../store";
import {Store} from '@ngrx/store';
import {first} from "rxjs/operators";
import {User} from "../../../../user/user";
import {UserService} from "../../../../user/user.service";
import {AuthService} from "../../../../auth/auth.service";
import {SignUpFor} from "../../../../add-website/typeFormAnswers";
import questions from './questions.json';
import questionsBooster from './questions-booster.json';
import {slideAnimation} from "../../../../shared/utils/animations";
import {PluginConnectService} from "../../../../shared/services/plugin-connect/plugin-connect.service";
import {UserSubscription} from "../../../../user/user-subscription";
import {Config} from "../../../../config/config";

interface IQuestion {
  question: string;
  slug: string;
  answers: IAnswer[];
}

interface IAnswer {
  title: string;
  value: string;
}

@Component({
    selector: 'db-question-step',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './question-step.component.html',
    styleUrls: ['./question-step.component.scss'],
    animations: [slideAnimation],
    standalone: false
})
export class QuestionStepComponent implements OnInit {

  @Input() signUpForAnswers: SignUpFor;
  @Input() userLocalStorage: any = {};
  @Input() boosterClient = false;
  @Input() userSubscription: UserSubscription;
  @Output() closeSignUpForStep: EventEmitter<void> = new EventEmitter<void>();

  public user: User;
  public questions: IQuestion[] = [];
  public activeQuestionIndex = 0;
  public answersData;
  public lastSelected: string | null = null;

  constructor(
    private _store: Store<DbStoreState>,
    private _router: Router,
    private _userService: UserService,
    private _authService: AuthService,
    private _pluginConnectService: PluginConnectService,
    private _cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.questions = this.boosterClient ? questionsBooster : questions;
    this.answersData = this.signUpForAnswers || {};
    if (this.boosterClient) {
      this.answersData['Action'] = {answer: 'booster', id: ''};
    }
    this._getUser();
  }

  public goToNextQuestion(data, slug) {
    this.answersData[slug] = {answer: data.title, id: data.value};
    if (this.isLastQuestion) {
      this.lastSelected = data.value;
      this.updateSignUpForData();
      return;
    }
    this.activeQuestionIndex++;
  }

  private get isLastQuestion(): boolean {
    return this.activeQuestionIndex === this.questions.length - 1;
  }

  private _getUser(): void {
    this._store.select(fromStore.getUser)
      .pipe(
        first(user => !!user, null),
      )
      .subscribe(user => {
        this.user = user;
        this._cdr.markForCheck();
      });
  }

  private updateSignUpForData(): void {
    this._authService.updateSignUpFor(this.answersData, true)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(() => {
        this._store.dispatch(new fromStore.LoadUser());
        this.updateUserLocalStorage();
        if (this.user && this.userSubscription &&  !Config.photoGalleryPluginIds.includes(this.userSubscription.product_id) && this._pluginConnectService.pluginData) {
          this._pluginConnectService.connect(this.user.email);
        }
        else {
          this.closeSignUpForStep.emit();
        }
      });
  }

  private updateUserLocalStorage(): void {
    this.userLocalStorage['signUpFor'] = this.answersData;
    this._userService.setToLocal(this.userLocalStorage)
      .pipe(
        first(response => !!response, null),
      )
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
        }
      });
  }
}
